// Design tokens and static sx constants for the Breakout Candidates feature.

export const C = {
  bg: '#fafbfd',
  surface: '#ffffff',
  border: '#e2e8f0',
  borderSoft: '#eef2f7',
  ink: '#1e293b',
  inkMid: '#475569',
  muted: '#64748b',
  mutedSoft: '#94a3b8',
  accent: '#2563eb',
  green: '#16a34a',
  greenSoft: '#dcfce7',
  red: '#dc2626',
  redSoft: '#fee2e2',
  amber: '#d97706',
  amberSoft: '#fef3c7',
  blue: '#2563eb',
  blueSoft: '#dbeafe',
  violet: '#7c3aed',
  violetSoft: '#ede9fe',
  cyan: '#0891b2',
  cyanSoft: '#e0f2fe',
};

export const FONT_NUM = 'inherit';

export const TABLE_HEAD_SX = {
  fontWeight: 700,
  fontSize: '0.65rem',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: '#94a3b8',
  bgcolor: '#f8fafc',
  borderBottom: '1px solid #e2e8f0',
  py: 1,
  whiteSpace: 'nowrap',
};

export const COMPACT_FIELD_SX = {
  minWidth: 0,
  '& .MuiInputBase-root': { fontSize: 13, height: 36, alignItems: 'center' },
  '& .MuiOutlinedInput-input': { py: '9.5px' },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    minHeight: 'unset',
    py: '9.5px',
  },
  '& .MuiInputLabel-root': {
    transform: 'translate(14px, -8px) scale(0.75)',
    transformOrigin: 'top left',
    px: 0.5,
    bgcolor: '#fafbfd',
  },
  '& .MuiInputLabel-shrink': { transform: 'translate(14px, -8px) scale(0.75)' },
  '& .MuiFormHelperText-root': { display: 'none' },
};

export const DETAIL_CARD_SX = {
  borderRadius: 2,
  overflow: 'hidden',
  bgcolor: '#fff',
  border: `1px solid ${C.border}`,
  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
};

export const PAGE_BUTTON_SX = {
  textTransform: 'none',
  fontSize: 13,
  fontWeight: 600,
  borderRadius: '4px',
  minWidth: { xs: 120, sm: 'auto' },
  color: C.inkMid,
  borderColor: C.border,
  '&:hover': { bgcolor: '#f8fafc', borderColor: '#cbd5e1' },
  '& .MuiButton-startIcon': { mr: 0.5 },
};
